import i18n from '@/i18n'
import { filterRulesMapped } from '@/tools/filterRules'
import { thingService } from '@/services/thing.service'
import { enterpriseService } from '@/services/enterprise.service'
import { mapActions, mapGetters } from 'vuex'
import { DialogType, SnackbarStyle, TypeIcons } from '@/constants/constants'
import { dialogTypes } from '@/constants/dialogTypes'
import { clone } from 'ramda'
import Vue from 'vue'
import AutocompleteComponent from '@/components/commons/autocomplete/AutocompleteComponent.vue'
import GoalsDialogComponent from './dialog/GoalsDialogComponent.vue'
import { dialogUtil, DialogGoals } from '@/tools/dialog'
import { bussinesTargetService } from '@/services/bussinesTarget.service'

export default {
    name: 'GoalsABMComponent',
    components: {
        GoalsDialogComponent,
        AutocompleteComponent,
    },
    data: () => ({
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los datos
        tableDataKey: 'id',
        // botones de cada fila
        rowActions: [
            // modificar
            {
                id: 1,
                name: i18n.t('modify'),
                color: 'blue',
                icon: 'fa-pen'
            },
            // eliminar
            {
                id: 2,
                name: i18n.t('delete'),
                color: 'red',
                icon: 'fa-trash-alt'
            },
        ],
        // botones del componente tabla
        tableComponentButtons: [],
        // tamaño de página (paginador)
        pageSize: 0,
        // número de página (paginador)
        pageNumber: 1,
        // total de documentos de la base de datos (paginador)
        pageTotal: null,
        // configuración del dialog del ABM
        dialog: {
            ...dialogTypes.GOALS,
        },
        // boolean para activar el diálogo
        showDialog: false,
        // título del dialog de edición
        editDialogTitle: i18n.t('goals.editDialog.titleNew'),
        // para activar el loading de la tabla
        loading: true,
        // arreglo de empresas para el selector de la tabla
        tableEnterpriseItems: [],
        enterpriseItems: [],
        // empresa seleccionada para filtrar las cosas de la tabla
        tableEnterpriseSelected: null,
        // arreglo de empresas para el selector de la tabla
        tableTypeItems: [],
        // tipo seleccionada para filtrar las cosas de la tabla
        tableTypeSelected: null,
        // Opción 'TODOS' para el selector de empresa
        all: {
            _id: 'ALL',
            name: i18n.t('all')
        },
        // bandera para desactivar los watchers de los selectores durante la carga inicial
        initialLoad: false,
        // configuración del dialog de carga masiva
        massiveUploadDialog: {
            ...dialogTypes.THING_MASSIVE_UPLOAD,
        },
        // model del dialog de carga masiva
        showMassiveUploadDialog: false,
        // banderas para identificar en la carga inicial si cambiaron los selectores
        enterpriseSelector: false,
        typeSelector: false,
        isClone: false,
    }),
    computed: {
        ...mapGetters('breadcrumbs', [
            'getBread'
        ]),
        /**
         * Devuelve un arreglo de empresas de acuerdo al valor del selector
         */
        abmSelectedEnterprises() {
            if (this.tableEnterpriseSelected) {
                if (this.tableEnterpriseSelected === 'ALL') {
                    return this.tableEnterpriseItems.filter(item => item._id !== 'ALL').map(item => item._id);
                }
                return [this.tableEnterpriseSelected];
            }
            return null;
        },
        /**
         * Devuelve un arreglo de tipos de acuerdo al valor del selector
         */
        abmSelectedTypes() {
            if (this.tableTypeSelected) {
                if (this.tableTypeSelected._id === 'ALL') {
                    return this.tableTypeItems.filter(item => item._id !== 'ALL').map(item => item._id);
                }
                return [this.tableTypeSelected._id];
            }
            return null;
        },
        /**
         *
         */
        enterprises() {
            return this.tableEnterpriseItems.filter(items => items._id !== this.all._id);
        }
    },
    created() {
        // Vuex watch del breadcrumb
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastElement = newBreads[newBreads.length - 1];
                if (!lastElement) {
                    this.cancel();
                    return;
                }
                this.dialog = dialogUtil.getDialog(lastElement.key, DialogGoals);
            },
            {deep: true});
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
        this.cleanBread()
    },

    async mounted() {
        // Botones de edición y eliminación múltiple
        this.tableComponentButtons.push(
            {
                id: 'add-dialog',
                tooltip: i18n.t('add'),
                icon: 'add',
                action: this.createNewObjetive.bind(this),
                selectedData: false,
            },
            {
                id: 'masive-delete',
                tooltip: i18n.t('multipleDelete'),
                icon: 'delete_outline',
                action: this.deleteTargets.bind(this),
                selectedData: true
            });
        await this.initialize();

    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        createNewObjetive() {
            this.dialog.model.isSingleUpdate = false;
            this.showCreateDialog();
        },
        /**
         * Inicialización del breadcrumb para alta/modificación
         */
        initBread() {
            const bread = {
                key: dialogTypes.GOALS.key,
                disabled: true,
                text: this.$t('goals.name')
            };
            this.pushBread(bread);
        },

        /**
         * Inicialización del breadcrumb para carga masiva
         */
        initBreadMassiveUpload() {
            const bread = {
                key: dialogTypes.THING_MASSIVE_UPLOAD.key,
                disabled: true,
                text: this.$t('equipment.massiveUpload.name')
            };
            this.pushBread(bread);
        },
        /**
         * Este método se ejecuta para inicializar los datos de la tabla.
         * Carga el selector de empresas y el selector de tipos y ejecuta el método para cargar los datos de la tabla.
         */
        async initialize() {
            this.initialLoad = true;

            // inicialización de los datos de selectores

            // tipos
            const types = await thingService.getTypesForSelector();
            if (types.length > 1) {
                this.tableTypeItems = [this.all];
                this.tableTypeItems = this.tableTypeItems.concat(this.tableTypeItems, types);
            } else {
                this.tableTypeItems = types;
            }
            this.tableTypeSelected = this.tableTypeItems.length ? this.tableTypeItems[0] : null;

            // empresas
            this.dialog.model.enterprises = await enterpriseService.getAllForSelector();
            this.tableEnterpriseItems = clone(this.dialog.model.enterprises);
            this.enterpriseItems = clone(this.dialog.model.enterprises);
            if (this.dialog.model.enterprises.length > 1) {
                this.tableEnterpriseItems.unshift(this.all);
            }
            this.tableEnterpriseSelected = this.tableEnterpriseItems.length ? this.tableEnterpriseItems[0]._id : null;

            // Si hay query params los asigna para incluirlos en la llamada al backend
            if (this.$route.query.pageSize && this.$route.query.pageNumber) {
                this.pageSize = Number(this.$route.query.pageSize);
                this.pageNumber = Number(this.$route.query.pageNumber);

                // Valida que los query-params sean correctos y completos
                if ((this.pageSize && this.pageSize <= 0)
                    || (this.pageNumber && this.pageNumber <= 0)
                    || (this.pageNumber && !this.pageSize)
                    || (!this.pageNumber && this.pageSize)) {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('error.invalidQueryParams'),
                        timeout: 6000,
                        style: SnackbarStyle.ERROR
                    });
                    this.pageSize = this.pageTotal;
                    this.pageNumber = 1;
                }
            } else {
                this.pageSize = this.pageTotal;
                this.pageNumber = 1;
            }

            // cargo la tabla con las cosas filtradas de acuerdo a los valores del selector
            await this.getData();
            this.resetFields();
            this.initBread();
            this.initialLoad = false;
        },
        /**
         * Este método se utiliza para obtener los datos de la tabla
         * @param {*} update
         */
        async getData(update = false) {
            this.loading = true;
            if (update) {
                this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes);
                this.pageSize = 50;
                this.pageNumber = 1;
            }
            let data = await thingService.findAllForGoalsABM(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes);

            if (this.enterpriseSelector || this.typeSelector) {
                this.enterpriseSelector = false;
                this.typeSelector = false;

                this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes);
                this.pageSize = 50;
                this.pageNumber = 1;

                data = await thingService.findAllForGoalsABM(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes);
            }
            // Se clonan los headers anteriores para mantener las columnas seleccionadas
            const lastTableHeaders = clone(this.tableHeaders);
            this.tableData.cleanAndUpdate(data.data);
            if (update) {
                Vue.nextTick(() => this.tableHeaders.cleanAndUpdate(lastTableHeaders));
            } else {
                this.tableHeaders.cleanAndUpdate(data.headers);
                this.setTableFilterRules();
            }
            this.loading = false;
        },
        /**
         * Refrescar la data
         */
        async refreshTable() {
            await this.getData(true);
        },
        /**
         * Reglas de filtrado de la tabla
         */
        setTableFilterRules() {
            this.tableFilterRules = {};
            this.tableHeaders.forEach(header => this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]);
        },
        /**
         * Reset el modelo del dialog de creación/actualización
         */
        resetFields() {
            if (this.dialog) {
                this.dialog.model = {
                    _id: null,
                    name: null,
                    description: null,
                    typeId: null,
                    gpsId: null,
                    enterpriseId: null,
                    currentActivity: null,
                    harvestFrontId: null,
                    fleetId: null,
                    sectorId: null,
                    groupId: null,
                    identificator: null,
                    color: '#0694de',
                    features: null,
                    hasOnBoardMonitor: null,
                    originWorkWidth: null,
                    config: {},
                    boxQuantity: null,
                    update: false,
                    reminderBy: [],
                    consumption: {},
                    isClone: false,
                    commodatum: false,
                    caliper: {},
                    serviceType: "",
                    varilla: {},
                    enterprises: []
                };
            }
        },

        /**
         * Eliminar objetivo(s)
         * @param {*} data
         */
        async deleteTargets(data) {
            this.openDialog({
                title: this.$t('goals.deleteTitle'),
                text: this.$t('goals.deleteText'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    let dataIds = data.map(target => target.id);
                    bussinesTargetService.deleteObjetives(dataIds).then(() => {
                        this.showSnackbar({
                            visible: true,
                            text: this.$t('goals.successDelete'),
                            timeout: 6000,
                            style: SnackbarStyle.SUCCESS
                        });
                        this.getData(true);
                    })
                },
                noAction: () => {
                }
            })
        },
        /**
         * Acción de los botones de cada fila (editar o eliminar)
         * @param {*} button
         * @param {*} data
         */
        rowButtonClicked(button, data) {
            switch (button.id) {
                case 1:
                    //Modificación individual
                    this.editDialogTitle = i18n.t('equipment.editDialog.titleEdit', {name: data.name});
                    this.dialog.model.isSingleUpdate = true;
                    this.getSelectedRowsData(data);
                    this.showCreateDialog();
                    this.isClone = false;
                    break;
                case 2:
                    // Acción de eliminar                   
                    this.openDialog({
                        title: this.$t('goals.deleteTitle'),
                        text: this.$t('goals.deleteText'),
                        type: DialogType.QUESTION,
                        overlayOpacity: 0.5,
                        actionButtons: true,
                        yesAction: async () => {
                            bussinesTargetService.deleteObjetives([data.id]).then(() => {
                                this.showSnackbar({
                                    visible: true,
                                    text: this.$t('goals.successDelete'),
                                    timeout: 6000,
                                    style: SnackbarStyle.SUCCESS
                                });
                                this.getData(true);
                            });
                        },
                        noAction: () => {
                        }
                    });
                    break;
                default:
                    console.error('Botón no implementado');
            }
        },
        getSelectedRowsData(data) {
            const equipmentData = {
                disabled: false,
                enterpriseId: data.enterpriseId,
                groupId: data.groupId,
                id: data.id,
                name: data.name,
                nodeType: 'THING',
                objetivesNames: data.objetivesNames,
                objetivesTableData: data.objetivesTableData,
                stateTargets: data.stateTargets,
            };
            this.dialog.model.selectedRowData = [equipmentData];
            this.dialog.model.enterpriseId = data.enterpriseId;
        },
        /**
         * Clic fuera del dialog
         */
        clickOutside() {
            this.cancel();
        },
        /**
         * Cancelar
         */
        cancel() {
            this.resetFields();
            this.showDialog = false;
        },

        showCreateDialog() {
            this.initBread();
            this.dialog.model.update = false;
            this.editDialogTitle = i18n.t('goals.editDialog.titleNew');
            this.showDialog = true;
        },
        /**
         * Paginador externo
         * @param {*} pageSize
         * @param {*} pageNumber
         */
        externalPaginator(pageSize, pageNumber) {
            this.pageNumber = Number(pageNumber);
            this.pageSize = Number(pageSize);
        },
        /**
         * Esta función se ejecuta cuando alguno de los selectores (empresa o tipo) cambia
         */
        async updateData() {
            // total de cosas
            this.pageTotal = await thingService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes);
            this.pageSize = this.pageTotal;
            this.pageNumber = 1;
            // datos
            await this.getData(true);
        },
        /**
         * Función que devuelve la imagen/icono del ABM según el tipo seleccionado
         *
         * Default: tractor
         * @param {*} typeKey
         */
        getTypeIcon(typeKey) {
            let icon = TypeIcons.DEFAULT;
            if (typeKey) {
                icon = TypeIcons[typeKey] ? TypeIcons[typeKey] : TypeIcons.DEFAULT;
            }
            return icon;
        },
        /**
         * Cuando se selecciona una empresa
         * @param {*} newValue
         */
        tableEnterpriseSelectedFunction(newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableEnterpriseSelected = newValue._id ? newValue._id : newValue;
            if (!this.initialLoad) {
                this.updateData();
            } else {
                this.enterpriseSelector = true;
            }
        },
        /**
         * Cuando se selecciona un tipo
         * @param {*} newValue
         */
        tableTypeSelectedFunction(newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableTypeSelected = newValue;
            if (!this.initialLoad) {
                this.updateData();
            } else {
                this.typeSelector = true;
            }
        },
        onEnterpriseSelect(event) {
            this.dialog.model.enterpriseId = event && event._id;
        }
    },
}
